import LocalCache from '@/utils/LocalCache'
// 壹心理鲸币账户服务协议
export const incomeRecordLocalCache = new LocalCache('incomeRecord-agree')
// 共享经济合作伙伴协议
export const SEPALocalCache = new LocalCache('SEPA-agree')
